import createItemFetcher from "../helpers/item";
import { createUseFetch } from "../helpers/fetchHooks";
export function createFileBrowserHeader(config) {
    const { computeFileBrowserHeaderUrl } = config;
    function computeItemId(config) {
        const { scenario, program, panel, element } = config;
        return `${scenario}_${program}_${panel}_${element}`;
    }
    return createItemFetcher(computeFileBrowserHeaderUrl, "FILEBROWSER", computeItemId);
}
const computeItemId = ({ scenario, cfg, element, }) => {
    return `${scenario}_${cfg}_${element}`;
};
const computeFileBrowserHeaderVFUrl = ({ scenario, cfg, element, }) => {
    return `api/v1/vf/browser/${scenario}/configs/${cfg}/${element}`;
};
const fileBrowserHeaderVF = createItemFetcher(computeFileBrowserHeaderVFUrl, "FILEBROWSER_VF", computeItemId);
export function createFileBrowserHeaderVF() {
    return fileBrowserHeaderVF;
}
export const useFileBrowserHeaderVF = createUseFetch(fileBrowserHeaderVF, (state) => state.filebrowserheadersVF);
export function createFileBrowserFiles(config) {
    const { computeFileBrowserFilesUrl } = config;
    function computeItemId(config) {
        const { relLocation } = config;
        return `${relLocation}`;
    }
    return createItemFetcher(computeFileBrowserFilesUrl, "FILEBROWSER_FILES", computeItemId);
}
export function createFileBrowserNapeos(config) {
    const { computeFileBrowserNapeosUrl } = config;
    function computeItemId(config) {
        const { relLocation } = config;
        return `${relLocation}`;
    }
    return createItemFetcher(computeFileBrowserNapeosUrl, "FILEBROWSER_NAPEOS", computeItemId);
}
//# sourceMappingURL=index.js.map